import { useCallback, useState } from 'react'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import {
    ACCESS_LOG_BASE,
    BackLink,
    AccessDetail,
    DocumentBundleAccessDetailView,
    batchAccessPath,
} from '../components/views/documentBundleAccessView'

// Sentinel-admin only; the view's API call re-checks `isAdminUser`.
function DocumentBundleAccessDetailContainer() {
    // Back link targets the owning batch once the record has loaded.
    const [backTo, setBackTo] = useState(ACCESS_LOG_BASE)
    const onLoaded = useCallback((access: AccessDetail) => setBackTo(batchAccessPath(access.batch_group)), [])

    return (
        <div className="documentBundleAccessDetail">
            <Sidebar />
            <MainView>
                <BackLink to={backTo} text="Back to batch accesses" />
                <ViewTitle text="Bundle Access Detail" />
                <DocumentBundleAccessDetailView onLoaded={onLoaded} />
            </MainView>
        </div>
    )
}

export default DocumentBundleAccessDetailContainer
